import { Action, createReducer, on } from '@ngrx/store'
import { fetch_calendar_details_success, load_calendar_summary_success_action } from '../action/calendar.action'
import { CalendarState, initialCalendarState } from '../state/calendar.state'

export function calendarReducer(state: CalendarState, action: Action) {
  return _calendarReducer(state, action)
}

export const _calendarReducer = createReducer(
  initialCalendarState,
  on(load_calendar_summary_success_action, (state, { calendar }) => {
    return {
      ...state,
      summary: calendar
    }
  }),
  on(fetch_calendar_details_success, (state, { calendar }) => {
    return {
      ...state,
      details: calendar
    }
  })
)
